import { localizedAsset } from '../../utils/languageUtils.js';
import { resolvePoKName } from '../../utils/domainUtils.js';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export default function ExampleDialog({ open, onClose }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;

    const url =
        lang === 'es'
            ? 'https://certificates.the-world-university.com/c/bc3ca656-8233-42b0-85e6-e6805b6bc626'
            : lang === 'pt'
              ? 'https://certificates.the-world-university.com/c/dff5a375-5c25-4bfa-9812-5d66a3bc5432'
              : 'https://certificates.the-world-university.com/c/15b2b130-7983-4800-8dfe-a8e785bf4ebc';

    return (
        <Dialog open={open} onClose={onClose} sx={{ '& .MuiPaper-root': { padding: 2, borderRadius: 5 } }}>
            <DialogTitle component="span" sx={{ textAlign: 'center', width: '100%' }}>
                <img
                    width="223"
                    height="157"
                    src={`/images/${localizedAsset('certificate_institution.webp', lang, 'en')}`}
                    alt="Digital Credential Example"
                />
                <Typography
                    variant="h3"
                    sx={{
                        fontSize: 14,
                        mt: 4,
                    }}
                >
                    {t('commons.main_description.actions.view_certificate.title', {
                        POK_NAME: resolvePoKName(),
                    })}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography
                    variant="h3"
                    sx={{
                        fontSize: 14,
                        fontWeight: 400,
                        textAlign: 'center',
                    }}
                >
                    {t('commons.main_description.actions.view_certificate.subtitle')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ alignSelf: 'center' }}>
                <Button variant={'outlined'} onClick={onClose}>
                    {t('commons.button.cancel')}
                </Button>
                <Button variant={'contained'} component={'a'} href={url} target={'_blank'} autoFocus>
                    {t('commons.main_description.actions.view_certificate.label')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
